import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

const initialState = {
  items: [],
  isFetching: false,
  isRequestFailed: false,
  isInitialized: false,
};

const blogs = createReducer(initialState, {
  [FETCH_BLOGS_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),

  [FETCH_BLOGS_SUCCESS]: (state, action) => ({
    ...state,
    ...action.payload,
    isFetching: false,
    isInitialized: true,
  }),

  [FETCH_BLOGS_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isInitialized: true,
  }),
});

export default blogs;
